import { ButtonHTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type GeolocationCtaProps = ButtonHTMLAttributes<HTMLButtonElement>

const GeolocationCta = ({ className, ...props }: GeolocationCtaProps) => {
  const { strings } = useStore()

  return (
    <button
      type="button"
      data-geolocation-cta
      className={cn(
        'flex items-center gap-spacing-2xs text-[white]/70 underline underline-offset-2 transition-colors duration-300 hover:text-[white]',
        className
      )}
      {...props}
    >
      <Typography variant="regular" component="span" className="condensed">
        {strings?.labels?.sales_network_use_location ||
          'Usa la tua Posizione Attuale'}
      </Typography>

      <div className="flex size-[2.5rem] items-center justify-center">
        <svg
          width="8"
          height="20"
          viewBox="0 0 8 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 19.25H6.75"
            stroke="#344054"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.625 6.75V15.0835M0.5 3.625C0.5 2.7962 0.82924 2.00134 1.41529 1.41529C2.00134 0.82924 2.7962 0.5 3.625 0.5C4.24307 0.5 4.84725 0.683278 5.36116 1.02666C5.87506 1.37004 6.2756 1.8581 6.51212 2.42911C6.74865 3.00013 6.81053 3.62847 6.68995 4.23466C6.56937 4.84085 6.27175 5.39767 5.83471 5.83471C5.39767 6.27175 4.84085 6.56937 4.23466 6.68995C3.62847 6.81053 3.00013 6.74865 2.42911 6.51212C1.8581 6.2756 1.37004 5.87506 1.02666 5.36116C0.683278 4.84725 0.5 4.24307 0.5 3.625Z"
            stroke="#F2F2F2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  )
}

export default GeolocationCta
